// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Lzf","rootNoMargin":"styles_rootNoMargin__2IRW_"};